import { Stack, CircularProgress } from "@mui/material";
import { FormPropertyProps } from "../../../FormProperty";
import { SelectTreeView } from "./TreeView";
import { SsqSelect } from "./SsqSelect";
import { usePropertyContext } from "../../../context/usePropertyContext";
import { useMemo } from "react";
import { getDataListOptionsWithOverrides } from "src/utils/ssq";
import { groupDataListOptions } from "src/utils/dataListOptions";

export const Select = (props: FormPropertyProps) => {
    const { property } = props;

    const { post, dataListValueOverrides } = usePropertyContext();

    const options = useMemo(
        () => getDataListOptionsWithOverrides(property.dataList, dataListValueOverrides),
        [property.dataList, dataListValueOverrides],
    );
    const groupedOptions = useMemo(() => groupDataListOptions(options), [options]);

    if (!post) return <CircularProgress />;

    const isGrouped = Object.keys(groupedOptions).length > 1;

    return (
        <Stack direction="column" gap="8px">
            {isGrouped ?
                <SelectTreeView {...props} groupedOptions={groupedOptions} options={options} />
            :   <SsqSelect {...props} options={options} />}
        </Stack>
    );
};
